import Vue from 'vue'
// vue已使用cdn引入
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

// element-ui已使用cdn引入
import '@/styles/element-ui/theme/index.css'
import ElementUI from 'element-ui'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import axios from 'axios'

import '@/icons' // icon
import '@/permission' // permission control

import XEUtils from 'xe-utils'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import '@/icons/icon/iconfont.css'

import moment from 'moment'

import Sortable from 'sortablejs';
import baseURL from '@/utils/baseUrl.js'
import '../src/utils/CLodopfuncs.js'

//全局时间选择器组件
import DatePicker from '@/components/general/DatePicker'
Vue.component("DatePicker", DatePicker)


import { electronPrint, electronTablePrint } from './utils/electronPrint.js'
Vue.prototype.$http = baseURL
Vue.prototype.$electronPrint = electronPrint
Vue.prototype.$electronTablePrint = electronTablePrint

Vue.use(VXETable)
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$XModal = VXETable.modal
Vue.prototype.$XEUtils = XEUtils
Vue.prototype.$XPrint = VXETable.print
Vue.prototype.$moment = moment
Vue.prototype.$sortable = Sortable
Vue.prototype.$axios = axios
Vue.prototype.$EventBus = new Vue()

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
